import { Chip, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { formatDateTime, formatNumber } from "@/features/shared";

/** Generation metadata read from response headers, never from the framed document. */
export const ReportSummaryBar = ({ metadata }) => (
  <Stack
    direction="row"
    spacing={1}
    useFlexGap
    sx={{ flexWrap: "wrap", alignItems: "center" }}
  >
    <Typography variant="caption" color="text.secondary" noWrap>
      {`Dibuat ${formatDateTime(metadata.generatedAt)} · ${formatNumber(
        metadata.rowCount
      )} baris`}
    </Typography>
    {metadata.hasInvalid && (
      <Chip size="small" color="error" label="Memuat nilai tidak valid" />
    )}
  </Stack>
);

ReportSummaryBar.propTypes = {
  metadata: PropTypes.shape({
    generatedAt: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    hasInvalid: PropTypes.bool.isRequired,
  }).isRequired,
};
